import React from "react";

export default function AspectRatioPicker({ selected, onSelect }) {
  const options = [
    { ratio: "9:16", label: "Story / Reel", description: "Best for TikTok, Instagram Reels, Shorts", icon: "📱" },
    { ratio: "3:4", label: "Pinterest Pin", description: "Ideal for Pinterest Ads", icon: "📌" },
    { ratio: "1:1", label: "Square Ad", description: "Balanced for social media", icon: "🔲" },
    { ratio: "4:3", label: "Classic TV", description: "Traditional video format", icon: "📺" },
    { ratio: "16:9", label: "YouTube / Facebook", description: "Widescreen for web & desktop", icon: "💻" },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
      {options.map(({ ratio, label, description, icon }) => (
        <div
          key={ratio}
          onClick={() => onSelect(ratio)}
          title={description}
          className={`cursor-pointer p-4 rounded-lg border text-center text-white transition-all duration-300 ${
            selected === ratio
              ? "border-pink-500 bg-pink-900/30"
              : "border-[#2A2A40] bg-[#1C1C2E] hover:border-pink-500/50 hover:bg-pink-800/10"
          }`}
        >
          <div className="text-3xl mb-2">{icon}</div>
          <div className="text-lg font-bold mb-1">{ratio}</div>
          <div className="text-xs text-white/60">{label}</div>
        </div>
      ))}
    </div>
  );
}
